import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { closeModal, openModal } from '../modals/modalActions';
import { closeKYC } from './KYCActions';

// Redux actions
const actions = {
  closeModal,
  openModal,
  closeKYC,
};

// Redux state
const mapState = state => ({
  auth: state.auth,
  async: state.async,
  kyc: state.kyc
});

class KYCContainer extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    async: PropTypes.object.isRequired
  };
  closeKYCModal = () => {
    this.props.closeModal();
    this.props.closeKYC();
  }

  render() {
    return null;
  }

  componentDidUpdate() {
    const { auth, kyc, openModal } = this.props;

    if (
      auth.isLoggedIn &&
      auth.isLoggedIn.kycActionRequired === 'MIN_KYC_REQUIRED' &&
      !kyc.close &&
      window.location.pathname !== '/accounts/login'
    ) {
      openModal('KYCModal', { payload: { closeModal: this.closeKYCModal, isLoggedIn: auth.isLoggedIn } });
    }
  }
}

export default connect(
  mapState,
  actions
)(KYCContainer);
